import React, { ComponentProps, forwardRef } from 'react';
import { Badge as MUIBadge, badgeClasses } from '@mui/material';

import { SHAPE_ROUNDED, SHAPE_SQUARE } from '@/mui/constants';

import type { ShapeProp } from '@/mui/types';

type CustomProps = {
  shape?: ShapeProp;
};

type Props = ComponentProps<typeof MUIBadge> & CustomProps;

const Badge = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { shape, sx, children, ...rest } = props;

  return (
    <MUIBadge
      ref={ref}
      {...rest}
      sx={{
        [`& .${badgeClasses.badge}`]: {
          ...(shape === SHAPE_SQUARE && { borderRadius: 0 }),
          ...(shape === SHAPE_ROUNDED && {
            borderRadius: (theme) => theme.shape.borderRadiusSmall,
          }),
        },
        ...sx,
      }}
    >
      {children}
    </MUIBadge>
  );
});

Badge.displayName = 'Badge';

export default Badge;
